import { useState } from "react";
import { Link } from "react-router-dom";

interface VIPUpgradePromptProps {
  onContactSupport?: () => void;
}

export default function VIPUpgradePrompt({ onContactSupport }: VIPUpgradePromptProps) {
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    onContactSupport?.();
  };

  return (
    <div className="relative bg-stone-900 rounded-3xl border border-amber-500/20 overflow-hidden">
      {/* Decorative gradient */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-rose-800/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" />

      <div className="relative px-6 md:px-10 py-10 md:py-14">
        <div className="flex flex-col items-center text-center max-w-xl mx-auto">
          {/* Crown icon */}
          <div className="w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mb-5">
            <i className="ri-vip-crown-line text-amber-400 text-2xl" />
          </div>

          <h2 className="font-display text-xl md:text-3xl font-bold text-white mb-3">
            此區域僅供 VIP 尊享
          </h2>
          <p className="font-body text-sm md:text-base text-stone-400 leading-relaxed mb-6">
            你正在瀏覽 VAMOSMALL 最高級別的認購專區。這裡匯聚限量珍稀貨源與高回報率的獨家商品。
            升級 VIP會員或以上等級，解鎖全部特權與商品詳情。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button
              onClick={() => setShowForm(true)}
              className="w-full sm:w-auto font-body text-sm font-semibold px-6 py-3 rounded-full bg-amber-500 text-stone-900 hover:bg-amber-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-customer-service-2-line mr-1.5" />
              聯繫客服升級
            </button>
          </div>

          <p className="font-body text-xs text-stone-500 mt-4">
            或先前往
            <Link to="/subscribe-trial" className="text-amber-400 hover:text-amber-300 transition-colors">
              認購體驗區
            </Link>
            感受認購魅力
          </p>
        </div>

        {/* Contact form */}
        {showForm && !submitted && (
          <div className="mt-8 pt-8 border-t border-stone-700 max-w-md mx-auto">
            <h3 className="font-display text-base font-semibold text-white text-center mb-4">
              申請 VIP 升級
            </h3>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="你的姓名"
                required
                className="w-full font-body text-sm px-4 py-3 rounded-xl bg-stone-800 border border-stone-700 text-white placeholder:text-stone-500 focus:border-amber-500/40 focus:ring-2 focus:ring-amber-500/10 outline-none transition-all"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="電子郵件"
                required
                className="w-full font-body text-sm px-4 py-3 rounded-xl bg-stone-800 border border-stone-700 text-white placeholder:text-stone-500 focus:border-amber-500/40 focus:ring-2 focus:ring-amber-500/10 outline-none transition-all"
              />
              <button
                type="submit"
                className="w-full font-body text-sm font-semibold py-3 rounded-full bg-amber-500 text-stone-900 hover:bg-amber-400 transition-colors whitespace-nowrap"
              >
                提交申請
              </button>
            </form>
          </div>
        )}

        {submitted && (
          <div className="mt-8 pt-8 border-t border-stone-700 max-w-md mx-auto text-center">
            <div className="w-12 h-12 rounded-full bg-emerald-500/10 flex items-center justify-center mx-auto mb-3">
              <i className="ri-check-line text-emerald-400 text-xl" />
            </div>
            <h3 className="font-display text-base font-semibold text-white mb-2">
              申請已送出
            </h3>
            <p className="font-body text-sm text-stone-400">
              我們的 VIP 專屬客服將於 24 小時內聯繫你，請留意電子郵件。
            </p>
          </div>
        )}
      </div>
    </div>
  );
}